/**
 * @generated SignedSource<<bee13d9cab64f2bbfc6e5e538f9c5468>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pricingGuidanceTracking_item$data = {
  readonly pricingGuidance: {
    readonly maxAmount: {
      readonly amount: number | null;
    } | null;
    readonly minAmount: {
      readonly amount: number | null;
    } | null;
    readonly price: {
      readonly amount: number | null;
    } | null;
  } | null;
  readonly " $fragmentType": "pricingGuidanceTracking_item";
};
export type pricingGuidanceTracking_item$key = {
  readonly " $data"?: pricingGuidanceTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "pricingGuidanceTracking_item"
};

(node as any).hash = "6215b8389e585e0569c28ed482e98709";

export default node;
